import { render } from "./CineMediasSection.vue?vue&type=template&id=49eef700&ts=true"
import script from "./CineMediasSection.vue?vue&type=script&lang=ts"
export * from "./CineMediasSection.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/filmin/press-center/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__